import { cloneDeep } from "lodash-es";
import type {
  ActionFunction,
  UserActionMetadata,
  UserActionsMetadataState,
} from "./types";

const setUserActionsMetadata: ActionFunction = (
  state: UserActionsMetadataState,
  payload: {
    metadata: UserActionMetadata;
  }
) => {
  return {
    metadata: cloneDeep(payload.metadata),
  };
};

export default setUserActionsMetadata;
